/* Fahrrad Rachow - Filter-Seitenleiste (Vorbild Lucky Bike)
   Ergaenzt die Dawn-Facets (filter_type: vertical):
   - feste Reihenfolge der Filtergruppen, die wichtigsten aufgeklappt
   - "+ X weitere anzeigen" nach 6 Eintraegen
   - Suchfeld bei langen Listen (Marke)
   - Farbpunkte bei der Farbe
   - Preis-Schieberegler
   - Fragen-Assistent wie bei Lucky Bike (Gelaende, Rahmenform, Budget)
   Laeuft nach jedem AJAX-Neuladen der Filter erneut (MutationObserver). */
(function () {
  'use strict';

  var ORDER = [
    'Kategorie',
    'Verfügbarkeit',
    'Preis',
    'Marke',
    'Hauptfarbe',
    'Rahmen-Form',
    'Rahmenhöhe',
    'Größe',
    'Laufradgröße',
    'E-Bike Motor Hersteller',
    'E-Bike Motor Bezeichnung',
    'E-Bike Motorposition',
    'E-Bike Akku Kapazität',
    'Schaltungstyp',
    'Anzahl Gänge',
    'Antriebsträger',
    'Rahmen-Material',
    'Modelljahr'
  ];
  var OPEN_COUNT = 8; // so viele Gruppen sind beim ersten Laden offen
  var LIMIT = 6; // so viele Eintraege sind sichtbar, bevor "weitere anzeigen" kommt
  var SEARCH_MIN = 12; // ab so vielen Eintraegen gibt es ein Suchfeld

  var COLORS = {
    schwarz: '#1f1f1f',
    grau: '#8b9096',
    'weiß': '#ffffff',
    weiss: '#ffffff',
    silber: 'linear-gradient(135deg,#f1f2f3,#a7acb1)',
    blau: '#2f5fa8',
    'grün': '#3f7d4e',
    gruen: '#3f7d4e',
    rot: '#c0392b',
    orange: '#e67e22',
    gelb: '#f2c230',
    'rosa & pink': '#e98fb5',
    violett: '#7d4fa0',
    braun: '#7a5233',
    'gold & kupfer': 'linear-gradient(135deg,#e2b85a,#b87333)',
    bunt: 'conic-gradient(#c0392b,#f2c230,#3f7d4e,#2f5fa8,#7d4fa0,#c0392b)'
  };

  var state = {
    expanded: {}, // details-id -> true
    query: {}, // details-id -> Suchbegriff
    openedOnce: false
  };

  function norm(s) {
    return (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function groupLabel(details) {
    var el =
      details.querySelector('.facets__summary-label') ||
      details.querySelector('.facets__summary span') ||
      details.querySelector('.mobile-facets__summary span');
    if (!el) return '';
    var text = '';
    el.childNodes.forEach(function (n) {
      if (n.nodeType === 3) text += n.textContent;
    });
    return (text || el.textContent).replace(/\(\d+\)/, '').replace(/\s+/g, ' ').trim();
  }

  function orderIndex(label) {
    var i = ORDER.map(norm).indexOf(norm(label));
    return i === -1 ? 999 : i;
  }

  /* ---------- Reihenfolge ---------- */
  function reorder(container, selector) {
    if (!container) return;
    var groups = Array.prototype.slice.call(container.querySelectorAll(':scope > ' + selector));
    if (groups.length < 2) return;
    var sorted = groups
      .map(function (g, i) {
        return { el: g, i: i, o: orderIndex(groupLabel(g)) };
      })
      .sort(function (a, b) {
        return a.o - b.o || a.i - b.i;
      })
      .map(function (x) {
        return x.el;
      });
    var same = sorted.every(function (g, i) {
      return g === groups[i];
    });
    if (same) return;
    var anchor = groups[groups.length - 1].nextSibling;
    sorted.forEach(function (g) {
      container.insertBefore(g, anchor);
    });
  }

  /* ---------- Beim ersten Laden: wichtigste Gruppen offen ---------- */
  function openInitial(form) {
    if (state.openedOnce || !form) return;
    var groups = form.querySelectorAll('#FacetsWrapperDesktop > details.js-filter');
    if (!groups.length) return;
    groups.forEach(function (d, i) {
      var active = d.querySelector('input[type="checkbox"]:checked');
      var price = Array.prototype.some.call(d.querySelectorAll('price-range input'), function (inp) {
        return inp.value !== '';
      });
      d.open = i < OPEN_COUNT || !!active || price;
    });
    state.openedOnce = true;
  }

  /* ---------- Liste: weitere anzeigen + Suche ---------- */
  function renderList(details) {
    var key = details.id;
    var list = details.querySelector('ul.facets__list--vertical');
    if (!list) return;
    var items = Array.prototype.slice.call(list.children);
    var q = norm(state.query[key]);
    var expanded = !!state.expanded[key];

    items.forEach(function (li, idx) {
      li.classList.remove('hidden', 'show-more-item');
      var text = norm((li.querySelector('.facet-checkbox__text-label') || li).textContent);
      var checked = !!li.querySelector('input:checked');
      var visible = q ? text.indexOf(q) !== -1 : expanded || idx < LIMIT || checked;
      li.classList.toggle('rf-hidden', !visible);
    });

    var btn = details.querySelector('.rf-more');
    var needsBtn = !q && items.length > LIMIT + 1;
    if (needsBtn && !btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rf-more';
      btn.addEventListener('click', function () {
        state.expanded[key] = !state.expanded[key];
        renderList(details);
      });
      (list.closest('fieldset') || list).insertAdjacentElement('afterend', btn);
    }
    if (btn) {
      btn.classList.toggle('rf-hidden', !needsBtn);
      var rest = items.length - LIMIT;
      var label = expanded ? 'Weniger anzeigen' : '+ ' + rest + ' weitere anzeigen';
      if (btn.textContent !== label) btn.textContent = label;
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function addSearch(details) {
    var key = details.id;
    var list = details.querySelector('ul.facets__list--vertical');
    if (!list || list.children.length < SEARCH_MIN) return;
    if (details.querySelector('.rf-search')) return;
    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'rf-search';
    input.placeholder = groupLabel(details) + ' suchen';
    input.setAttribute('aria-label', groupLabel(details) + ' suchen');
    input.value = state.query[key] || '';
    // Eingaben im Suchfeld duerfen das Filterformular nicht absenden
    ['input', 'change', 'keydown'].forEach(function (ev) {
      input.addEventListener(ev, function (e) {
        e.stopPropagation();
        if (ev === 'keydown' && e.key === 'Enter') e.preventDefault();
        if (ev === 'input') {
          state.query[key] = input.value;
          renderList(details);
        }
      });
    });
    var fieldset = list.closest('fieldset') || list;
    fieldset.parentNode.insertBefore(input, fieldset);
  }

  /* ---------- Farbpunkte ---------- */
  function addSwatches(root) {
    root.querySelectorAll('details.js-filter').forEach(function (d) {
      if (!/farbe/i.test(groupLabel(d))) return;
      d.querySelectorAll('label.facet-checkbox, label.mobile-facets__label').forEach(function (label) {
        if (label.querySelector('.rf-swatch')) return;
        var name = norm((label.querySelector('.facet-checkbox__text-label') || label).textContent);
        var color = COLORS[name];
        if (!color) return;
        var dot = document.createElement('span');
        dot.className = 'rf-swatch';
        dot.setAttribute('aria-hidden', 'true');
        dot.style.background = color;
        label.classList.add('rf-color');
        var text = label.querySelector('.facet-checkbox__text');
        label.insertBefore(dot, text);
      });
    });
  }

  /* ---------- Preis-Schieberegler ---------- */
  function parseNum(v) {
    if (!v) return NaN;
    var s = String(v).replace(/[^\d,.\-]/g, '');
    if (s.indexOf(',') !== -1) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(/\.(?=\d{3}(\D|$))/g, '');
    return parseFloat(s);
  }

  function addPriceSlider(form) {
    var pr = form && form.querySelector('price-range');
    if (!pr || pr.parentNode.querySelector('.rf-range')) return;
    var inputs = pr.querySelectorAll('input');
    if (inputs.length < 2) return;
    var minIn = inputs[0];
    var maxIn = inputs[1];
    var max = Math.ceil(parseNum(maxIn.getAttribute('data-max') || maxIn.getAttribute('max') || maxIn.placeholder));
    if (!isFinite(max) || max <= 0) return;
    var step = max > 2000 ? 50 : 10;
    max = Math.ceil(max / step) * step;

    var wrap = document.createElement('div');
    wrap.className = 'rf-range';
    wrap.innerHTML =
      '<div class="rf-range__track"></div><div class="rf-range__fill"></div>' +
      '<input type="range" aria-label="Preis von" min="0" max="' + max + '" step="' + step + '">' +
      '<input type="range" aria-label="Preis bis" min="0" max="' + max + '" step="' + step + '">';
    var lo = wrap.children[2];
    var hi = wrap.children[3];
    var fill = wrap.children[1];
    var curLo = parseNum(minIn.value);
    var curHi = parseNum(maxIn.value);
    lo.value = isFinite(curLo) ? curLo : 0;
    hi.value = isFinite(curHi) ? curHi : max;

    function paint() {
      var a = (lo.value / max) * 100;
      var b = (hi.value / max) * 100;
      fill.style.left = a + '%';
      fill.style.width = Math.max(b - a, 0) + '%';
    }
    function sync(e) {
      e.stopPropagation();
      if (+lo.value > +hi.value - step) {
        if (e.target === lo) lo.value = +hi.value - step;
        else hi.value = +lo.value + step;
      }
      minIn.value = +lo.value > 0 ? lo.value : '';
      maxIn.value = +hi.value < max ? hi.value : '';
      paint();
    }
    function commit(e) {
      e.stopPropagation();
      [minIn, maxIn].forEach(function (inp) {
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
      maxIn.dispatchEvent(new Event('input', { bubbles: true }));
    }
    [lo, hi].forEach(function (r) {
      r.addEventListener('input', sync);
      r.addEventListener('change', commit);
    });
    paint();
    pr.insertAdjacentElement('afterend', wrap);
  }

  /* ---------- Fragen-Assistent (Vorbild Lucky Bike) ----------
     Schritt 1: Wo fahren? (Kategorie)  Schritt 2: Rahmenform  Schritt 3: Budget
     Jede Antwort setzt einen normalen Filter. Schritte ohne passende Produkte
     werden uebersprungen. Der aktuelle Schritt bleibt beim Filtern erhalten. */
  var ICON = {
    road: '<path d="M17 41L22 7M31 41L26 7M24 11v4M24 20v5M24 30v7M6 41h36"/>',
    field: '<circle cx="13" cy="11" r="4"/><path d="M13 15v9M5 31c11-4 27-4 38 0M5 40c8-6 18-8 26-8M19 40l4-8M31 40l-2-8"/>',
    terrain: '<path d="M4 40l12-18 6 8 8-14 14 24z"/><path d="M26 23l4 3 3-3"/>',
    diamant: '<circle cx="9" cy="33" r="1.5"/><circle cx="41" cy="33" r="1.5"/><path d="M9 33l9-18h17L22 33z M18 15l4 18 M35 15l1.5 6L41 33M16 12h5"/>',
    wave: '<circle cx="9" cy="33" r="1.5"/><circle cx="41" cy="33" r="1.5"/><path d="M9 33l9-18 4 18H9 M35 13c-2 9-7 20-13 20 M35 13l1.5 7L41 33M16 12h5"/>',
    trapez: '<circle cx="9" cy="33" r="1.5"/><circle cx="41" cy="33" r="1.5"/><path d="M9 33l9-18 4 18H9 M20 24l15-9 M35 15c-4 6-8 12-13 18 M35 15l1.5 6L41 33M16 12h5"/>',
    coin1: '<ellipse cx="24" cy="30" rx="10" ry="4"/><path d="M14 30v5c0 2.2 4.5 4 10 4s10-1.8 10-4v-5"/>',
    coin2: '<ellipse cx="24" cy="22" rx="10" ry="4"/><path d="M14 22v5c0 2.2 4.5 4 10 4s10-1.8 10-4v-5M14 27v6c0 2.2 4.5 4 10 4s10-1.8 10-4v-6"/>',
    coin3: '<ellipse cx="24" cy="14" rx="10" ry="4"/><path d="M14 14v5c0 2.2 4.5 4 10 4s10-1.8 10-4v-5M14 19v6c0 2.2 4.5 4 10 4s10-1.8 10-4v-6M14 25v6c0 2.2 4.5 4 10 4s10-1.8 10-4v-6M14 31v5c0 2.2 4.5 4 10 4s10-1.8 10-4v-5"/>'
  };

  function svg(name) {
    return '<svg class="rf-ride__icon" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICON[name] + '</svg>';
  }

  function euro(n) {
    return n.toLocaleString('de-DE') + ' €';
  }

  function filterForm() {
    return document.getElementById('FacetFiltersForm') || document.getElementById('FacetFiltersFormMobile');
  }

  // Werte einer Filtergruppe: { 'citybike': input, ... }
  function groupInputs(label) {
    var form = filterForm();
    if (!form) return null;
    var group = Array.prototype.find.call(form.querySelectorAll('details.js-filter'), function (d) {
      return norm(groupLabel(d)) === norm(label);
    });
    if (!group) return null;
    var map = {};
    group.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
      var lab = inp.closest('label');
      var text = lab && lab.querySelector('.facet-checkbox__text-label');
      map[norm(text ? text.textContent : inp.value)] = inp;
    });
    return map;
  }

  function priceMax() {
    var inp = document.querySelector('#main-collection-filters price-range input[name$="lte"]');
    var max = inp ? parseNum(inp.getAttribute('data-max') || inp.placeholder) : NaN;
    return isFinite(max) ? max : 0;
  }

  function budgetBands() {
    var max = priceMax();
    var ebike = /\/collections\/e-/.test(location.pathname);
    if (ebike && (!max || max > 4000)) return [[0, 2500], [2500, 4000], [4000, null]];
    if (!max || max > 2000) return [[0, 1000], [1000, 2000], [2000, null]];
    if (max > 800) return [[0, 400], [400, 800], [800, null]];
    return [[0, 300], [300, 600], [600, null]];
  }

  function steps() {
    var b = budgetBands();
    return [
      {
        title: 'Wo möchtest du hauptsächlich fahren?',
        group: 'Kategorie',
        options: [
          { label: 'Auf der Straße', icon: 'road', values: ['Citybike', 'Urbanbike', 'Trekkingbike', 'Rennrad', 'Fitnessbike'] },
          { label: 'Auf Feldwegen', icon: 'field', values: ['Trekkingbike', 'Crossbike', 'Gravel', 'Reiserad'] },
          { label: 'Im Gelände', icon: 'terrain', values: ['Hardtail', 'Fully', 'MTB / ATB'] }
        ]
      },
      {
        title: 'Welche Rahmenform bevorzugst du?',
        group: 'Rahmen-Form',
        options: [
          { label: 'Diamant', icon: 'diamant', values: ['Diamant / Herren'] },
          { label: 'Tiefeinstieg / Wave', icon: 'wave', values: ['Tiefeinsteiger / Wave'] },
          { label: 'Trapez', icon: 'trapez', values: ['Trapez'] }
        ]
      },
      {
        title: 'Wie hoch ist dein Budget?',
        price: true,
        options: [
          { label: 'Bis ' + euro(b[0][1]), icon: 'coin1', range: b[0] },
          { label: euro(b[1][0]) + ' – ' + euro(b[1][1]), icon: 'coin2', range: b[1] },
          { label: 'Über ' + euro(b[2][0]), icon: 'coin3', range: b[2] }
        ]
      }
    ];
  }

  var STORE_KEY = 'rf-wizard:' + location.pathname;
  function loadStep() {
    try {
      var v = parseInt(sessionStorage.getItem(STORE_KEY), 10);
      return isFinite(v) ? v : 0;
    } catch (e) {
      return 0;
    }
  }
  function saveStep(n) {
    try {
      sessionStorage.setItem(STORE_KEY, String(n));
    } catch (e) {}
  }

  // Ist die Option in dieser Kollektion waehlbar, und ist sie gerade aktiv?
  function optionState(step, opt) {
    var params = new URLSearchParams(location.search);
    if (step.price) {
      var lo = params.get('filter.v.price.gte');
      var hi = params.get('filter.v.price.lte');
      var max = priceMax();
      var available = !max || opt.range[0] < max;
      var active =
        String(lo || '0') === String(opt.range[0] || 0) &&
        String(hi || '') === String(opt.range[1] === null ? '' : opt.range[1]);
      return { available: available, active: active && (lo !== null || hi !== null) };
    }
    var map = groupInputs(step.group);
    if (!map) return { available: false, active: false };
    var present = opt.values.map(norm).filter(function (v) {
      return map[v] && !map[v].disabled;
    });
    var checked = Object.keys(map).filter(function (k) {
      return map[k].checked;
    });
    var active =
      present.length > 0 &&
      present.every(function (v) {
        return map[v].checked;
      }) &&
      checked.length === present.length;
    return { available: present.length > 0, active: active, present: present, map: map };
  }

  function stepAvailable(step) {
    return step.options.some(function (o) {
      return optionState(step, o).available;
    });
  }

  function go(params) {
    params.delete('page');
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(params.toString());
    } else {
      window.location.search = params.toString();
    }
  }

  function choose(step, opt) {
    var st = optionState(step, opt);
    var params = new URLSearchParams(location.search);
    if (step.price) {
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      if (!st.active) {
        if (opt.range[0]) params.set('filter.v.price.gte', opt.range[0]);
        if (opt.range[1] !== null) params.set('filter.v.price.lte', opt.range[1]);
      }
    } else {
      var paramName = st.map[st.present[0]].name;
      params.delete(paramName);
      if (!st.active) {
        st.present.forEach(function (v) {
          params.append(paramName, st.map[v].value);
        });
      }
    }
    return params;
  }

  function nextAvailable(all, from, dir) {
    var i = from;
    while (i >= 0 && i < all.length && !stepAvailable(all[i])) i += dir;
    return i;
  }

  function summary(all) {
    var parts = [];
    all.forEach(function (s) {
      s.options.forEach(function (o) {
        if (optionState(s, o).active) parts.push(o.label);
      });
    });
    return parts;
  }

  function renderWizard() {
    var box = document.querySelector('.rf-ride[data-rf-wizard]');
    if (!box) return;
    var all = steps();
    if (!all.some(stepAvailable)) {
      box.classList.add('rf-hidden');
      return;
    }
    box.classList.remove('rf-hidden');

    var idx = loadStep();
    if (idx < all.length) idx = nextAvailable(all, Math.max(idx, 0), 1);
    var first = nextAvailable(all, 0, 1);

    var html;
    if (idx >= all.length) {
      var chosen = summary(all);
      html =
        '<div class="rf-ride__done">' +
        '<p class="rf-ride__done-text"><strong>Deine Auswahl:</strong> ' +
        (chosen.length ? chosen.join(', ') : 'alle Bikes') +
        '</p>' +
        '<button type="button" class="rf-ride__link" data-rf-restart>Neu starten</button>' +
        '</div>';
    } else {
      var step = all[idx];
      var tiles = step.options
        .map(function (o, i) {
          var st = optionState(step, o);
          return (
            '<button type="button" class="rf-ride__tile" data-rf-opt="' + i + '" aria-pressed="' + st.active + '"' +
            (st.available ? '' : ' disabled') + '>' + svg(o.icon) +
            '<span class="rf-ride__label">' + o.label + '</span></button>'
          );
        })
        .join('');
      html =
        '<p class="rf-ride__title">' + step.title + '</p>' +
        '<div class="rf-ride__grid">' + tiles + '</div>' +
        '<div class="rf-ride__nav">' +
        (idx > first ? '<button type="button" class="rf-ride__link rf-ride__link--back" data-rf-back>Zurück</button>' : '<span></span>') +
        '<button type="button" class="rf-ride__link rf-ride__link--skip" data-rf-skip>Überspringen</button>' +
        '</div>';
    }
    if (box.getAttribute('data-rf-html') !== html) {
      box.innerHTML = html;
      box.setAttribute('data-rf-html', html);
    }

    if (box.dataset.rfBound) return;
    box.dataset.rfBound = '1';
    box.addEventListener('click', function (e) {
      var all2 = steps();
      var cur = loadStep();
      if (cur < all2.length) cur = nextAvailable(all2, Math.max(cur, 0), 1);
      var t = e.target.closest('button');
      if (!t || t.disabled) return;
      if (t.hasAttribute('data-rf-restart')) {
        var params = new URLSearchParams(location.search);
        all2.forEach(function (s) {
          if (s.price) {
            params.delete('filter.v.price.gte');
            params.delete('filter.v.price.lte');
          } else {
            var m = groupInputs(s.group);
            var any = m && m[Object.keys(m)[0]];
            if (any) params.delete(any.name);
          }
        });
        saveStep(0);
        go(params);
        return;
      }
      if (t.hasAttribute('data-rf-back')) {
        saveStep(nextAvailable(all2, cur - 1, -1));
        renderWizard();
        return;
      }
      if (t.hasAttribute('data-rf-skip')) {
        saveStep(nextAvailable(all2, cur + 1, 1));
        renderWizard();
        return;
      }
      if (t.hasAttribute('data-rf-opt')) {
        var step = all2[cur];
        var opt = step.options[+t.getAttribute('data-rf-opt')];
        var p = choose(step, opt);
        saveStep(nextAvailable(all2, cur + 1, 1));
        go(p);
      }
    });
  }

  /* ---------- "&nbsp;" im Hinweis "Der hoechste Preis ist ..." reparieren ---------- */
  function fixPriceNote(root) {
    if (!root) return;
    root.querySelectorAll('.facets__selected, .mobile-facets__info').forEach(function (el) {
      if (el.textContent.indexOf('&nbsp;') !== -1) {
        el.textContent = el.textContent.replace(/&nbsp;/g, ' ');
      }
    });
  }

  /* ---------- Alles anwenden ---------- */
  function apply() {
    fixPriceNote(document.getElementById('main-collection-filters'));
    var desktop = document.getElementById('FacetFiltersForm');
    if (desktop && desktop.classList.contains('facets__form-vertical')) {
      reorder(document.getElementById('FacetsWrapperDesktop'), 'details.js-filter');
      openInitial(desktop);
      desktop.querySelectorAll('#FacetsWrapperDesktop > details.js-filter').forEach(function (d) {
        addSearch(d);
        renderList(d);
      });
      addSwatches(desktop);
      addPriceSlider(desktop);
    }
    var mobile = document.getElementById('FacetsWrapperMobile');
    if (mobile) {
      reorder(mobile, 'details.mobile-facets__details');
      addSwatches(mobile);
    }
    renderWizard();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      apply();
    }, 0);
  }

  function init() {
    apply();
    var observer = new MutationObserver(schedule);
    ['main-collection-filters', 'ProductGridContainer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
